/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idRoletaCheckin: string;
  idCorretorSistemaOrigem: string;
  opcaoAusencia: string;
}

export function useRecepcaoAusencia() {
  const postData = async (props: Props) => {
    const RECEPCAO_AUSENCIA = `${leadsWebEnviroment}/common/checkin/recepcao/ausencia/v1/`;
    const response = await instance.put(RECEPCAO_AUSENCIA, {
      idRoletaCheckin: props.idRoletaCheckin,
      idCorretorSistemaOrigem: props.idCorretorSistemaOrigem,
      opcaoAusencia: Number(props.opcaoAusencia),
    });
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: postData,
    onSuccess: () => { },
    onError: () => { },
  });

  return mutation;
}
